import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ddbc055c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbc055c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddbc055c')) {
      api.createRecord('ddbc055c', component.options)
    } else {
      api.reload('ddbc055c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ddbc055c&scoped=true&", function () {
      api.rerender('ddbc055c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GzPYln3VwOYm/JS/comp/Accordion.vue"
export default component.exports